/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const NumberConfig = core.serialization.object({
    decimalPlaces: core.serialization.number().optional(),
});
